/* eslint-disable max-len */
import React from 'react';
import classnames from 'classnames';

import { getCurrentPlacementInfo, normalizePreviewTexts } from '../ad-preview-library-wrapper/util';

export const getOnRenderPlacement = (props, containerClassName) => {
  const {
    isMultimediaAd,
    isMultiMediaAdsPhase2Enabled,
    previewTexts,
    opacityChangeEnabled,
    logo,
    hotspots,
    i18n,
    permissions,
  } = props || {};

  const onRenderPlacement = (placement, AdPlacementComponent) => {
    const { placementMeta, isPlacementIncluded } = placement || {};
    const { placementType } = placementMeta || {};

    const {
      previewStringKey,
      showAdditionalDisclaimer,
      isTextPlacement,
    } = getCurrentPlacementInfo(placementType) || {};

    const isPlacementEnabled = isTextPlacement // always enable placements without images, such as outlook placements
      || (!opacityChangeEnabled || isPlacementIncluded);

    const unifiedPreviewTexts = normalizePreviewTexts(previewTexts, placementType);

    return (
      <div className={classnames('new-responsive-ad-preview-container', containerClassName, !isPlacementEnabled && 'disabled')}>
        <AdPlacementComponent
          isEnabled
          placementData={placement}
          {...unifiedPreviewTexts}
          finalUrl={previewTexts.url}
          logo={logo}
          hotspots={hotspots}
          i18n={i18n}
          extraPermissions={permissions}
          displayFinalUrlOrigin={isMultimediaAd && isMultiMediaAdsPhase2Enabled}
        />
        <div className="preview-type-string">
          {previewStringKey ? i18n.getString(previewStringKey) : ''}
        </div>
        {
            showAdditionalDisclaimer && !isMultiMediaAdsPhase2Enabled &&
            <div className="additional-disclaimer">
              {i18n.getString(isMultimediaAd ? 'ImageExperience_Additional_Disclaimer_Message_MultimediaAd' : 'ImageExperience_Additional_Disclaimer_Message')}
            </div>
        }
      </div>
    );
  };
  return onRenderPlacement;
};
